import { useNotify } from '../contexts/NotificationContext';

export const useNotifyHook = () => {
    const notify = useNotify();

    return {
        // Basic notifications
        success: (title, message = '', options = {}) => {
            return notify.showSuccess(title, message, {
                duration: 4000,
                showClose: true,
                ...options
            });
        },
        
        error: (title, message = '', options = {}) => {
            return notify.showError(title, message, {
                duration: 6000,
                showClose: true,
                ...options
            });
        },
        
        warning: (title, message = '', options = {}) => {
            return notify.showWarning(title, message, {
                duration: 5000,
                showClose: true,
                ...options
            });
        },
        
        info: (title, message = '', options = {}) => {
            return notify.showInfo(title, message, {
                duration: 4000,
                showClose: true,
                ...options
            });
        },
        
        // Confirm dialog
        confirm: ({
            title,
            message,
            confirmText = 'Confirm',
            cancelText = 'Cancel',
            onConfirm,
            onCancel,
            type = 'warning'
        }) => {
            return notify.showConfirm({
                title,
                message,
                confirmText,
                cancelText,
                onConfirm,
                onCancel,
                type
            });
        },
        
        // Remove notification
        remove: (id) => {
            return notify.removeNotification(id);
        },
        
        // Clear all
        clearAll: () => {
            return notify.clearAllNotifications();
        }
    };
};